import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { IIDN } from 'src/app/shared/models/IIDN';
import { INavMenu } from '../model/nav-menu.model';
//import { ISessionInfo } from '../model/session-info.model';
import { APIClient } from '../../api-client/contracts/api-client.service';
import { ISessionInfo } from '../model/session-info.model';

@Injectable()
export class NavMenuService {
  private navMenuUrl = 'navigation';
  private sessionInfoUrl = 'session';
  private isNavMenuChanged$: Subject<boolean> = new ReplaySubject<boolean>(undefined);

  constructor(
    private apiClient: APIClient
  ) { }

  getNavBarInfo(): Observable<INavMenu> {
    return this.apiClient.get<INavMenu>(this.navMenuUrl);
  }

  setSessionInfo(sessionInfo: ISessionInfo): Observable<any> {
    return this.apiClient
      .post<ISessionInfo>(this.sessionInfoUrl, sessionInfo);
  }

  removeSessionInfo(): Observable<any> {
    return this.apiClient.delete<string>(this.sessionInfoUrl);
  }

  getIDNAndFacilitiesForCurrentUser(): Observable<IIDN[]> {
    return this.apiClient.get<IIDN[]>(`${this.navMenuUrl}/getIDNAndFacilitiesForCurrentUser`);
  }

  onNavMenuChange(isChanged: boolean) {
    this.isNavMenuChanged$.next(isChanged);
  }

  navMenuChangeSubscription(): Observable<boolean> {
    return this.isNavMenuChanged$;
  }


}

